var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowBet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.29289 4.79289C5.68342 4.40237 6.31658 4.40237 6.70711 4.79289L21.7071 19.7929C22.0976 20.1834 22.0976 20.8166 21.7071 21.2071C21.3166 21.5976 20.6834 21.5976 20.2929 21.2071L5.29289 6.20711C4.90237 5.81658 4.90237 5.18342 5.29289 4.79289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06898 10.3967C7.53785 10.9009 7.09082 11.4061 6.74978 11.8243C6.26491 12.4188 6.25256 13.2449 6.71518 13.8569C7.85548 15.3656 10.2417 18 13.0007 18C13.7541 18 14.4796 17.8036 15.1596 17.4873L8.06898 10.3967Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6379 15.7229C17.1669 16.1739 16.6393 16.6121 16.0682 16.9817L8.82184 9.73532C9.34205 9.31479 9.91795 8.92416 10.5354 8.62043L17.6379 15.7229Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.335 15.0059C18.7088 14.5944 19.0292 14.1971 19.2863 13.8569C19.7489 13.2449 19.7365 12.4188 19.2517 11.8243C18.0982 10.4098 15.7322 8 13.0007 8C12.5029 8 12.0172 8.08006 11.5487 8.21956L18.335 15.0059Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowBet);
export default __webpack_public_path__ + "static/media/show-bet.3f365b4430ab3cb6862775e879c62de1.svg";
export { ForwardRef as ReactComponent };